import { defineMessages } from 'react-intl';
import sharedMessages from '../shared-messages';

const defaultMsg_README = `
#README #Welcome!

# Welcome to ** AtomEditor ** !

AE is a Scratch editor developed based on TurboWarp. We have added more features and addons~~as well as many BUGs and features~~!

Here we are demonstrating the README feature. To learn more, please visit [AtomEditor Documentation](https://editors.astras.top/document/)!

For secondary development based on AtomEditor, please visit our [code repository](https://github.com/AtomEditor).

Go to [this link](https://github.com/RemixWorld-cn/Atom-Editor/issues) to report BUGs to us!

> [!NOTE]
> [Follow us on Bilibili](https://space.bilibili.com/3691007061264515)`;

let messages = defineMessages({
    variable: {
        defaultMessage: 'my variable',
        description: 'Name for the default variable',
        id: 'gui.defaultProject.variable'
    },
    tip: {
        defaultMessage: defaultMsg_README,
        description: 'a README',
        id: 'tw.defaultProject.readme'
    }
});

messages = { ...messages, ...sharedMessages };

// use the default message if a translation function is not passed
const defaultTranslator = msgObj => msgObj.defaultMessage;

/**
 * Generate a localized version of the default project
 * @param {function} translateFunction a function to use for translating the default names
 * @return {object} the project data json for the default project
 */
const projectData = translateFunction => {
    const translator = translateFunction || defaultTranslator;
    return ({
        targets: [
            {
                isStage: true,
                name: 'Stage',
                variables: {
                    '`jEk@4|i[#Fk?(8x)AV.-my variable': [
                        translator(messages.variable),
                        0
                    ]
                },
                lists: {},
                broadcasts: {},
                blocks: {},
                currentCostume: 0,
                costumes: [
                    {
                        assetId: 'cd21514d0531fdffb22204e0ec5ed84a',
                        name: translator(messages.backdrop, { index: 1 }),
                        md5ext: 'cd21514d0531fdffb22204e0ec5ed84a.svg',
                        dataFormat: 'svg',
                        rotationCenterX: 240,
                        rotationCenterY: 180
                    }
                ],
                sounds: [],
                volume: 100
            },
            
        ],
        meta: {
            semver: '3.0.0',
            vm: '0.1.0',
            agent: ''
        }
    });
};


export default projectData;
